import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  IconButton as MuiIconButton,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import OptionIcon from "../icons/OptionIcon";

const components = {
  MuiIconButton: {
    styleOverrides: {
      root: {
        borderRadius: 0,
        backgroundColor: "transparent",
        ":hover": { backgroundColor: "rgb(219, 233, 247)" },
        "& svg": { stroke: "rgb(53 41 41 / 54%)" },
        ":hover svg": { stroke: "rgb(81, 159, 226)" },
      },
    },
  },
};
const defaultTheme = createTheme({ components });

components.MuiIconButton.styleOverrides.root = {
  borderRadius: 0,
  backgroundColor: "#ffffff",
  ":hover": { backgroundColor: "#ffffff" },
  "& svg": { stroke: "rgb(81, 159, 226)" },
};

const activeTheme = createTheme({ components });

/**
 * Primary UI component for user interaction
 */
export default function IconButton({ Icon=OptionIcon, active, width, onClick, elRef, ...props }) {
  const [svgWidth, setSvgWidth] = useState("20px");
  const [theme, setTheme] = useState(defaultTheme);

  useEffect(() => {
    if (width) {
      setSvgWidth(width);
    }
  }, [width]);

  useEffect(() => {
    setTheme(active ? activeTheme : defaultTheme);
  }, [active]);

  return (
    <ThemeProvider theme={theme}>
      <MuiIconButton onClick={onClick} {...props} ref={elRef}>
        <Icon width={svgWidth} />
      </MuiIconButton>
    </ThemeProvider>
  );
}

IconButton.propTypes = {
  /**
   * Button Icon
   */
  Icon: PropTypes.func,
  /**
   * Is the button in 'pressed' state?
   */
  active: PropTypes.bool,
  /**
   * Optional click handler
   */
  onClick: PropTypes.func,
};

IconButton.defaultProps = {
  active: false,
  // onClick: undefined,
};
